/**
 * В настройках лежит маппленый `IManifestInfo`, а не манифест целиком — отсюда суффикс `Info`.
 * Манифест целиком слишком дорого тащить в HTML-страницу, реестру микрофронтов он достаётся
 * на ноде напрямую.
 */
export const DESKTOP_FILTERS_MANIFEST_INFO_SETTING_KEY = 'desktopFiltersManifestInfo';
export const SEARCH_STRING_MANIFEST_INFO_SETTING_KEY = 'searchStringManifestInfo';
